import {meService} from "@/src/modules/core/services/me";
import type {Me} from "@/src/modules/core/types";

/**
 * Property managers must have at least one property to use the rest of the app.
 * Admins and senior supervisors can bypass (full access without a selected property).
 */
export function meRequiresPropertyBeforeUse(me: Me | null | undefined): boolean {
  if (!me) return false;
  if (me.isResident) return false;
  if (me.isAdmin || me.isSeniorSupervisor) return false;
  if (!me.isPropertyManager) return false;
  return me.properties.length === 0;
}

/**
 * Enforce the "no properties" redirect + modal only when the user may create a property.
 * Officers and other roles without `property store` must not be locked to /properties.
 */
export function shouldEnforcePropertySetupGate(me: Me | null | undefined): boolean {
  if (!meRequiresPropertyBeforeUse(me)) return false;
  return meService.getHasPermission("property store");
}